import styled from "styled-components/macro";

export const CarouselWrapper = styled.div`
  margin: 0px 0px 46px;
  width: 100%;

      @media ${props => props.theme.device.mobile} {
        margin-bottom: 0;
    }

  &.LIVE_EVENT{
    width: calc(100% + 20px - 556px - 30px);
  }
  .slick-slider .slick-list{
    padding-bottom: 20px;

    .slick-slide > div {
      padding: 0;
    }
  }
`;